import { render, staticRenderFns } from "./IconFlag.vue?vue&type=template&id=467dfaaa"
import script from "./IconFlag.vue?vue&type=script&lang=js"
export * from "./IconFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports